export const EDITOR_VIOLATION_OPTIONS = [
  "id",
  "name",
  "introducedAt",
  "deletedAt",
  "statusTranslate",
];
